import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {StateService} from "../../services/StateService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {GrowthPlanService} from "../../tpiq-services/growth-plan.service";
import {PageTitleService} from "../../services/PageTitle";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {v4 as uuid} from 'uuid';
import {EventsService} from "../../tpiq-services/events.service";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TpiqFroalaViewComponent} from "../../tpiq-froala-view/tpiq-froala-view.component";
import {TpiqCustomDatepicker} from "../../directives/tpiq-custom-datepicker";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import { environment } from '../../../environments/environment';

declare var _: any;
declare let moment: any;

@Component({
  selector: 'app-events',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, FileUploadModule, FroalaEditorModule,
    MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule, TpiqFroalaViewComponent, TpiqCustomDatepicker],
  templateUrl: './events.component.html',
  styleUrl: './events.component.scss'
})
export class EventsComponent implements OnInit, OnDestroy {
  org: string;
  userId: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  routeSub: any;
  reveal: any = {
    createOrEditEvent: false,
    showEvent: false
  };
  editorOptions = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Enter description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  editMode: boolean = false;
  currentPlan: string;
  currentSelectedEventsType = 'All';
  growthEvents: Array<any> = [];
  event: any = {
    location: 'Online, private'
  };
  minDate: any;
  uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  logoFiles = [];
  selectedEvent: any;

  startIndex = 0;
  endIndex = 4; // Display 4 items at a time
  visibleEvents: Array<any> = [];
  upcomingEvents: Array<any> = [];
  normalEvents: Array<any> = [];
  frequencyTypes: Array<any> = [{name: 'Weekly'}, {name: 'Monthly'}];

  constructor(private titleService: PageTitleService, private stateService: StateService, private _router: Router,
              private loadingService: LoadingService, private switchBoard: SwitchBoard, private toastService: ToastService,
              private eventsService: EventsService, private taxStrategyServices: ManageTaxStrategiesServices,
              private growthPlanService: GrowthPlanService, private taxPlanningService: TaxPlanningService) {
  }

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.minDate = moment().format('MM/DD/YYYY');
    this.titleService.setPageTitle('Events');
    this.getAllEventsData();
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data) {
        this.removeEvent(toast.data);
      }
    });
    this.taxPlanningService.getSubscriptionStatus(this.org,this.userId).subscribe(response => {
      this.currentPlan = response.plan;
    });
  }

  removeEvent(event) {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.removePlan(this.org, this.userId, event.id)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Event deleted successfully');
        this.getAllEventsData();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to delete event`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  getAllEventsData() {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getAllPlans(this.org, this.userId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.normalEvents = response.schedules;
        _.each(this.normalEvents, (event) => {
          event.logoBg = {
            background: 'url("' + event.thumbnailUrl + '") center center no-repeat',
            'background-size': 'contain'
          };
          event.timeValue = this.formatedTimeValue(event);
        });
        this.upcomingEvents = response.upcomingEvents || [];
        _.each(this.upcomingEvents, (event) => {
          event.logoBg = {
            background: 'url("' + event.thumbnailUrl + '") center center no-repeat',
            'background-size': 'contain'
          };
          event.timeValue = this.formatedTimeValue(event);
        });
        this.updateVisibleEvents();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get events`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  hideReveal(revealFlag) {
    this.event = {
      location: 'Online, private'
    };
    this.logoFiles = [];
    this.reveal[revealFlag] = false;
  }

  deleteEvent(event) {
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', event);
  }

  addNewEvent() {
    this.event = {
      location: 'Online, private'
    };
    this.editMode = false
    this.reveal.createOrEditEvent = true;
    this.uploaderUpdate();
    this.buildItemForm();

  }

  createOrEditEvent() {
    if (this.validateData()) {
      this.loadingService.triggerLoadingEvent(true);
      this.growthPlanService.createOrEditPlan(this.org, this.userId, this.event)
        .subscribe((response) => {
          this.loadingService.triggerLoadingEvent(false);
          const successMsg = (this.editMode) ? 'Event updated successfully' : 'Event created successfully';
          this.toastService.pop(TOAST_TYPE.success, successMsg);
          this.getAllEventsData();
          this.hideReveal('createOrEditEvent');
        }, (error) => {
          this.loadingService.triggerLoadingEvent(false);
          const message = error.message ? error.message : `Failed To create/update event`;
          try {
            this.toastService.pop(TOAST_TYPE.error, message);
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, message);
          }
        });
    }
  }

  validateData() {
    if (!this.event.name) {
      this.toastService.pop(TOAST_TYPE.error, 'Title is mandatory');
      return false;
    }
    if (!this.event.description) {
      this.toastService.pop(TOAST_TYPE.error, 'Description is mandatory');
      return false;
    }
    if (this.event.recurring) {
      if (!this.event.startDate) {
        this.toastService.pop(TOAST_TYPE.error, 'Start Date is mandatory');
        return false;
      }
      if (!this.event.endDate) {
        this.toastService.pop(TOAST_TYPE.error, 'End Date is mandatory');
        return false;
      }
    } else {
      if (!this.event.date) {
        this.toastService.pop(TOAST_TYPE.error, 'Date is mandatory');
        return false;
      }
    }
    if (!this.event.timeRange) {
      this.toastService.pop(TOAST_TYPE.error, 'Time is mandatory');
      return false;
    }
    return true;
  }

  selectEventType(type) {
    this.currentSelectedEventsType = type;
    if (type === 'Growth Plan') {
      this.getGrowthPlanEvents();
    } else if (type === 'All') {
      this.getAllEventsData();
    }
  }

  setEventDate($event, type?) {
    if (type && type === 'start') {
      this.event.startDate = $event;
    } else if (type && type === 'end') {
      this.event.endDate = $event;
    } else {
      this.event.date = $event;
    }
  }

  fileDropOver($event, type?){
    this.loadingService.triggerLoadingEvent(true);
    this.uploader.uploadAll();
  }

  fileOverBase($event, type?){
    this.hasBaseDropZoneOver = $event;
  }

  uploaderUpdate() {
    const base = this;
    const docUrl: any = this.taxStrategyServices.getFirmLogoUrl(this.org, Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  buildItemForm() {
    const base = this;
    const user: any = Session.getUser();
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceType = "firm_logo";
      payload.sourceId = uuid();
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploader.progress = 100;
        const document: any = JSON.parse(response);
        this.event.thumbnailUrl = document.temporaryURL;
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.temporaryURL;
          this.logoFiles = [];
          this.logoFiles.push(obj);
        }
        this.loadingService.triggerLoadingEvent(false);
      } else {
        this.resetUploader();
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Upload Logo');
        this.loadingService.triggerLoadingEvent(false);
      }
    };
  }

  resetUploader() {
    this.uploader.queue.forEach((item) => {
      item.remove();
    });
  }

  deleteDocumentFile(file, index, type?){
    this.logoFiles.splice(index, 1);
    if (this.logoFiles.length === 0) {
      this.event.thumbnailUrl = '';
    }
  }

  handleEventClick(event) {
    if (this.currentPlan?.toLowerCase().includes('growth')) {
      this.showEventInfo(event);
    } else {
      this.selectedEvent = "";
      this.reveal.showEvent = false;
    }
  }

  showEventInfo(event) {
    this.selectedEvent = event;
    this.reveal.showEvent = true;
  }

  eventRegisterLink(event) {
    if (event.link) {
      window.open(event.link);
    }
  }

  getGrowthPlanEvents() {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getAllPlans(this.org, this.userId, 'growth')
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.growthEvents = response.schedules || [];
        _.each(this.growthEvents, (event) => {
          event.logoBg = {
            background: 'url("' + event.thumbnailUrl + '") center center no-repeat',
            'background-size': 'contain'
          };
          event.timeValue = this.formatedTimeValue(event);
        });
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get growth plans data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  previous() {
    if (this.startIndex > 0) {
      this.startIndex--;
      this.endIndex--;
      this.updateVisibleEvents();
    }
  }

  next() {
    if (this.endIndex < this.upcomingEvents.length) {
      this.startIndex++;
      this.endIndex++;
      this.updateVisibleEvents();
    }
  }

  updateVisibleEvents() {
    this.visibleEvents = this.upcomingEvents.slice(this.startIndex, this.endIndex);
    const eventColors = ['#ECFDF3', '#EFF8FF', '#F8F2FF', '#FFF6DC'];
    _.each(this.visibleEvents, (event, i) => {
      event.bgColor = eventColors[i] || eventColors[0];
    });
  }

  openEventForEdit(event) {
    this.reveal.createOrEditEvent = true;
    this.editMode = true;
    this.event = event;
    this.uploaderUpdate();
    this.buildItemForm();
  }

  editOneOnOne() {
    if (this.org === 'test-taxplaniq' || this.org === 'stag-taxplaniq' || this.org === 'trialtaxplaniq') {
      this.reveal.oneOnOneEdit = true;
    }
  }

  oneOnOneSchedule(linkData) {
    if (linkData && linkData.link) {
      window.open(linkData.link);
    }
  }

  setFrequency($event){
    this.event.frequency = $event.name;
  }

  formatedTimeValue(plan) {
    let timeValue = '';
    if (plan.timeRange) {
      const [hour, minute] = plan.timeRange.split(':').map(num => parseInt(num, 10));

      let meridian = 'AM';

      if (hour >= 12) {
        meridian = 'PM';
      }
      timeValue = `${plan.timeRange} ${meridian} CT`;
    } else {
      timeValue = ''; // Clear the result if no time is selected
    }
    return timeValue;
  }

}
